import { t as translate } from "i18next"
import { useTranslation } from "react-i18next"

// New keys are discovered and pushed to the backend via local_translations/
// (collect.mjs + push.mjs), run manually - not from the client at render time.
export const autoTranslate = ({
  key,
  value,
}: {
  key: string
  value: string
}) => {
  const translatedValue = translate(key)
  return translatedValue === key ? value : translatedValue
}

export function useAutoTranslation() {
  useTranslation()

  return { t: autoTranslate }
}
